import { createSelector } from 'reselect';
import { every } from 'lodash';
import { isPresent } from 'helpers/string_helpers';

export const getDatabase = state => state.static.database;
export const getErrors = state => state.form.errors;
export const getImportRequest = state => state.form.importRequest;
export const getPaths = state => state.static.paths;
export const getSourceOptions = state => state.static.sourceOptions;

export const getImport = state => state.importer.import;
export const getCurrentFile = state => state.importer.currentFile;
export const getImportFiles = state => state.importer.files;
export const getImportStatusType = state => state.importer.import.statusType;

export const getCurrentStep = state => state.stepper.currentStep;

export const getRequiredFields = state => state.mapping.requiredFields;
export const getColumnMappings = state => state.mapping.columnMappings;
export const getFileMapping = state => state.mapping.fileMapping;
export const getRecordsCount = state => state.mapping.recordsCount;
export const getFieldsOptions = state => state.mapping.fieldOptions;
export const getRecord = state => state.mapping.record;
export const getRecordIndex = state => state.mapping.recordIndex;
export const getIgnoredRecord = state => state.mapping.ignoredRecord;
export const getIgnoredRecordIndex = state => state.mapping.ignoredRecordIndex;

export const canSave = createSelector(
  [getImportRequest],
  (importRequest) => {
    if (importRequest.files.length === 0) {
      return;
    }

    const requiredFields = ['name', 'source'];
    if (importRequest.source === 'other') {
      requiredFields.push('customSourceName');
    }

    return every(requiredFields, field => isPresent(importRequest[field]));
  }
);
